import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { WindowService } from '../../services/window-dialogs/window.service';
import { SortBot } from '../../helpers/sort';
import * as moment from 'moment';
import { Message, SelectItem } from 'primeng/primeng';
import { AdminPermissionTypes } from '@models/domain/admin.permission.item';
import { AdminItemArray } from '@models/domain/admin.item';
import { GlobalAdminBrowseLogsRequest } from '@models/ss-api/requests/global.admin.browse.logs.request';
import { AdminBrowseLogItemArray } from '@models/ss-api/responses/admin.browse.logs.response';
import { LicenseManager } from 'app/managers/License.manager';

@Component({
    selector: 'admin-logs',
    templateUrl: './admin.logs.component.html',
    styleUrls: ['./admin.logs.component.scss']
})
export class AdminLogsComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = false;

    AdminBrowseLogs = new AdminBrowseLogItemArray;


    AdminOptions: SelectItem[];
    SelectedAdmin : SelectItem;
    SelectedAdminID : number = null;

    _today = moment();

    EndDate: Date = moment(this._today).toDate();
    StartDate : Date = moment(this._today).subtract(1, 'months').toDate();

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;
    
    constructor(private dialogService: DialogService, private api: ssApiService, private gb: GlobalService, private windowService: WindowService) { }

    ngOnInit() {
        
        this.gb.SetPageTitle('Admin Logs');
        
        this.InitAdminOptions();
        this.GetLogs();

    }

    

    GetLogs() {

        let request = new GlobalAdminBrowseLogsRequest();
        request.StartDate = this.StartDate;
        request.EndDate = this.EndDate;
        request.AdminID = this.SelectedAdminID;
        
        console.log( this.SelectedAdmin );

        console.log("New Request : ", request);

        this.IsBusy = true;

        let disposable = this.api.GlobalAdminBrowseLogs( request ).subscribe( result => {
            disposable.unsubscribe();
            this.IsBusy = false;

            console.log(result.Data);
            this.AdminBrowseLogs = result.Data;

        });
    
    }


    InitAdminOptions() {
        this.AdminOptions = [];
    
        //this.IsBusy = true;
    
        let disposable = this.api.AdminsByPermissionType( AdminPermissionTypes.AppearInTicketingDropdown ).subscribe(response => {
            disposable.unsubscribe();
    
            response.Data = SortBot.SortAuto<AdminItemArray>(response.Data, 'FirstName');
    
            //this.IsBusy = false;
            
            this.AdminOptions.push({ label : 'All Admins', value : null });

            response.Data.forEach(admin => {
                this.AdminOptions.push({ label: admin.FirstName + ' ' + admin.LastName, value: admin.AdminID });
            });

            this.SelectedAdmin = this.AdminOptions[0];

        });
    

    }


    paginateSalesReport(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }


    onLicenseClick(license: string) {

        // show dialog

        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(license, true);


    }

    // ////////////////////////////////////
    // SORT STUFF
    // ////////////////////////////////////

    sortByDate() { SortBot.SortAuto(this.AdminBrowseLogs, 'DateTimeCreated'); }

    sortByName() { SortBot.SortAuto(this.AdminBrowseLogs, 'AdminName'); }

    sortByKey() { SortBot.SortAuto(this.AdminBrowseLogs, 'LicenseKey'); }

    sortByMember() { SortBot.SortAuto(this.AdminBrowseLogs, 'MemberName'); }



}
